import React from 'react';
import { useState, useEffect, } from "react";
import { Formik,Form,Field,ErrorMessage } from 'formik';
import { ConfigProvider,Select, Table } from "antd";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoIosAdd } from "react-icons/io";
import { AppVersionInfos, getAppVersionInfo } from '../../../Api/Settings/Configuration/AppVersion';
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { capitalizeFirstLetter } from '../../Common/Captilization';
import * as Yup from "yup";


const AppVersionInfo=()=>{
    const validationSchema = Yup.object()
    .shape({
      current_version:Yup.string()
      .required("Current Version is required"),
      //  .matches(/^[A-Za-z1-9]+\s\d+\.\d+$/, "Invalid version format"),
    updated_version:Yup.string().required("Latest Version is required"),
    // .matches(/^[A-Za-z]+\s\d+\.\d+$/, "Invalid version format"),
    app_url:Yup.string().required("App URL is required")
    .url("Invalid URL format"),
    device_type:Yup.string().required("Device Type is required"),
    mandatory_update:Yup.string().required("Mandatory Update is required"),
    });
    const [activePage, setActivePage] = useState(1);
    const [togglepage, setTogglePage] = useState(1);
    const crud=sessionStorage.getItem("crud_permission")
      const getStatusOptions = () => {
            return [
            { label: "Android", value: "android" },
            { label: "iOS", value: "ios" },
        ];
  };
  const dispatch=useDispatch();
  const itemsper = 5;

    useEffect(() => {

      getAppVersionInfo(dispatch);
    }, []);
  const options = getStatusOptions();
const appVersionInfo= useSelector((state) => state.crm.app_versioninfo) || [];
const indexOfLastItem = activePage * itemsper;
  const indexOfFirstItem = indexOfLastItem - itemsper;
const currentItems=appVersionInfo.slice(indexOfFirstItem, indexOfLastItem)
console.log(currentItems,"aaaaappp")

  const handlePageChange = (selectedPage) => {
    setActivePage(selectedPage);
    console.log("Selected page:", selectedPage);
  };

    const handleSubmit = async (values) => {
      console.log(values, "app version values");
      try {
            const response = await AppVersionInfos(values);
            getAppVersionInfo(dispatch)
            console.log("API Response:", response);
          } catch (err) {
            console.error("Submission error:", err);
          } finally {
            setActivePage(1)
            setTogglePage(1);
          }

    };
     
     console.log(itemsper,'itemsper');
     
      const columns = [
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          S.No
        </div>
      ),
      width: "8vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsper + (index + 1);

        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {serialNumber}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Current Version
        </h1>
      ),

      render: (row) => {
        return (
          <div className=" text-[1vw] flex items-center justify-center text-[#1F487C]">
            {row.current_version?row.current_version:"-"}
          </div>
        );
      },
    },

    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Latest Version
        </h1>
      ),

      render: (row) => {
        return (
          <div className="text-[1vw] flex items-center justify-center text-[#1F487C]">
            {row.updated_version?row.updated_version:"-"}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Device
        </h1>
      ),

      render: (row) => {
        return (
          <div className="text-[1vw] flex items-center justify-center text-[#1F487C]">
            {row.device_type?row.device_type==="android"?"Android":"iOS":"-"}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Mandatory Update
        </h1>
      ),

      render: (row) => {
        return (
          <div className="text-[1vw] flex items-center justify-center text-[#1F487C]">
            {row.mandatory_update===null?"-": row.mandatory_update?"Yes" : "No"}
          </div>
        );
      },
    },
    
  ];
  const data =
    currentItems?.length > 0 &&
    currentItems?.map((item) => ({
      key: item.id,
      current_version: item.current_version,
      updated_version: item.updated_version,
      device_type: item.device_type,
      mandatory_update: item.mandatory_update,
    }))
    console.log(data.length,"datalength")
  
    return(
<>
      {togglepage === 1 ? (
        <div className="flex justify-end mt-[2vw] mr-[2vw]">
          <button
            className={`bg-white text-[#1F487C] border-[0.1vw] border-b-[0.2vw] border-r-[0.2vw] border-[#1F487C] rounded-[0.5vw] py-[0.25vw] outline-none flex items-center  px-[1vw] gap-[0.25vw] ${crud?.includes("delete")||crud?.includes("view")||crud?.includes("update") ? "cursor-not-allowed":"cursor-pointer"}`}
            onClick={() => {
              setTogglePage(2);
            }}
            disabled={crud?.includes("delete")||crud?.includes("view")||crud?.includes("update")}
          >
            <IoIosAdd size={"1.5vw"} />{" "}
            <span className="text-[1.2vw]">Add</span>
          </button>
        </div>
      ) : (
        ""
      )}
{
togglepage===1?

                <div className='p-[2vw]'>
                      <Table
                            className="custom-table "
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                          />
                </div>:                  <Formik
                    initialValues={{
                      mandatory_update : "",
                      app_url:"",
                      current_version:"",
                      updated_version:"",
                      device_type:"",
                    }}
                    validationSchema={validationSchema}
                              onSubmit={(values) => {
            handleSubmit(values);

            console.log("Form Submitted valuesvalues:", values);
          }}
                
                    enableReinitialize
                  >
                    {({
                      handleSubmit,setFieldValue,handleChange,isSubmitting
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div>
<div className="grid grid-cols-2 px-[5vw] gap-y-[1.5vw] pt-[1.5vw] gap-x-[8vw] overflow-y-scroll">
  <div className="col-span-1 grid grid-cols-2 text-left">
    
    {/* Label Section */}
    <div className="flex items-center justify-start col-span-1">
      <label className="text-[#1F4B7F] font-bold text-[1.1vw]">
        Current Version
      </label>
      <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
    </div>

    {/* Input Section */}
    <div className="col-span-1">
      <Field
        type="text"
        name="current_version"
       onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z1-9.]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
}}
        className="border-r-[0.2vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw] placeholder-[#1F487C] border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none"
      />
      <ErrorMessage
        name="current_version"
        component="div"
        className="text-red-500 text-[0.8vw]"
      />
    </div>

  </div>


<div className="col-span-1 grid grid-cols-2 text-left">
  
  {/* Label Section */}
  <div className="col-span-1 flex items-center justify-start">
    <label className="text-[#1F4B7F] font-bold text-[1.1vw]">
      Latest Version
    </label>
    <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
  </div>

  {/* Input Section */}
  <div className="col-span-1">
    <Field
      type="text"
      name="updated_version"
             onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z1-9.]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
}}
      className="border-r-[0.2vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw] placeholder-[#1F487C] border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none"
    />
    <ErrorMessage
      name="updated_version"
      component="div"
      className="text-red-500 text-[0.8vw]"
    />
  </div>

</div>

<div className="col-span-1 grid grid-cols-2 text-left">
  
  {/* Label Section */}
  <div className="col-span-1 flex items-center justify-start">
    <label className="text-[#1F4B7F] font-bold text-[1.1vw]">
      App URL
    </label>
    <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
  </div>

  {/* Input Section */}
  <div className="col-span-1">
    <Field
      type="text"
      name="app_url"
      onChange ={(e) =>{
                                 let inputValue = e.target.value;                           
                                  inputValue=inputValue.replace(/\s+/g, "");
                                  handleChange({
                                  target: { name: e.target.name, value: inputValue },
                                  });
                              }}
      className="border-r-[0.2vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw] placeholder-[#1F487C] border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none"
    />
    <ErrorMessage
      name="app_url"
      component="div"
      className="text-red-500 text-[0.8vw]"
    />
  </div>

</div>

<div className="col-span-1 grid grid-cols-2 text-left">
  {/* Label Section */}
  <div className="flex items-center justify-start col-span-1">
    <label className="text-[#1F4B7F] font-bold text-[1.1vw]">
      Device
    </label>
    <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
  </div>

  {/* Select Dropdown Section */}
  <div className="col-span-1 relative">
    <ConfigProvider
      theme={{
        components: {
          Select: {
            optionActiveBg: "#aebed1",
            optionSelectedColor: "#FFF",
            optionSelectedBg: "#e5e5e5",
            optionHeight: "2",
          },
        },
      }}
    >
      <Select
  showSearch
  name="device_type"
  className="custom-select mt-[0.5vw] bg-white outline-none w-full h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw] border-r-[0.25vw] border-b-[0.25vw] placeholder-[#1F487C]"
  placeholder="Select Device"
  optionFilterProp="value"
  suffixIcon={
    <span style={{ fontSize: "1vw", color: "#1f487c" }}>
      <IoMdArrowDropdown size="2vw" />
    </span>
  }
  style={{ padding: 1 }}
//   value={device_type} // <-- Bind to Formik value
  onChange={(value) => setFieldValue("device_type", value)} // <-- Update Formik state
  options={[
    {
      value: "",
      label: (
        <div className="text-[1vw] px-[0.2vw] pb-[0.1vw] text-[#a9a9a9]">
          Select Device
        </div>
      ),
      disabled: true,
    },
    ...options?.map((item) => ({
      value: item.value,
      label: (
        <div className="flex items-center text-[1vw] gap-x-[0.5vw] px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
          <span className="text-[1vw]">{item.label}</span>
        </div>
      ),
    })),
  ]}
/>

    </ConfigProvider>
    <ErrorMessage
      name="device_type"
      component="div"
      className="text-red-500 text-[0.8vw] "
    />
  </div>
</div>
<div className='col-span-2 flex items-center justify-center space-x-10 mt-[0.5vw]'>
 <div className="flex items-center justify-center ">
    <label className="text-[#1F4B7F] font-bold text-[1.1vw]">
      Mandatory Update
    </label>
    <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
  </div>
<div className='col-span-1 flex'>
            <label className="flex items-center pr-[2vw]">
        <Field
          type="radio"
          name="mandatory_update"
          value="true"
          className="w-[1vw] h-[1vw] accent-[#1F4B7F]"
        />
        <span className="text-[#1F4B7F] text-[1.1vw] cursor-pointer font-medium pl-[0.5vw]">Yes</span>
      </label>

      <label className="flex items-center">
        <Field
          type="radio"
          name="mandatory_update"
          value="false"
          className="w-[1vw] h-[1vw] accent-[#1F4B7F]"
        />
        <span className="text-[#1F4B7F] text-[1.1vw] cursor-pointer font-medium pl-[0.5vw]">No</span>
      </label>
</div>
      </div>
 
       <ErrorMessage
      name="mandatory_update"
      component="div"
      className="text-red-500 text-[0.8vw] col-span-2 flex justify-center items-start -mt-[1vw]"
    />


  <div className="col-span-2 flex justify-center items-center gap-x-4 pb-[1vw] mt-[0.5vw] ">
        <button type='button' className="cursor-pointer px-[0.75vw] py-[0.5vw] border-[#1F487C] border-[0.1vw]  text-[#1F487C] font-semibold rounded-md shadow-sm hover:shadow-none shadow-[#1F487C] text-[1vw] bg-white  w-[10vw] text-center" onClick={() => {
                      setTogglePage(1);
                  
                      setActivePage(1);
                    }}>
      Back
    </button>
    <button 
    type="submit" 
    disabled={isSubmitting}
    className="cursor-pointer px-[0.75vw] py-[0.5vw] w-[10vw] border-[#1F487C] border-[0.1vw]  text-white bg-[#1F487C] font-semibold rounded-md shadow-sm hover:shadow-none shadow-[#1F487C] text-[1vw]">
      Submit
    </button>
</div>
                          </div>


                        </div>
                      </Form>
                    )}
                  </Formik>
}
      {togglepage === 1 ? (
        <div className=''>
          {appVersionInfo?.length > itemsper && (
            <div className="flex justify-end pr-[2.5vw] pb-[1.5vw]">
              <ReactPaginate
                activePage={activePage}
                itemsCountPerPage={itemsper}
                totalItemsCount={appVersionInfo?.length}
                pageRangeDisplayed={3}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link "
                activeClass="active"
                prevPageText={
                  <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                }
                nextPageText={
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                }
                firstPageText={
                  <FontAwesomeIcon icon={faAngleDoubleLeft} size="1x" />
                }
                lastPageText={
                  <FontAwesomeIcon icon={faAngleDoubleRight} size="1x" />
                }
              />
            </div>
          )}
        </div>
      ) : (
        ""
      )}
</>
                  
    )

}
export default AppVersionInfo